import { updateMomentLocale } from './translation';

export const initializeLocalization = (store) => {
  const getInitialLanguage = () => {
    const currentState = store.getState();

    if (currentState.locale?.languages?.length > 0) {
      const activeLanguageObj = currentState.locale.languages.find((lang) => lang.active);
      if (activeLanguageObj?.code) {
        return activeLanguageObj.code;
      }
    }

    const savedLanguage = localStorage.getItem('activeLanguage');
    if (savedLanguage) {
      return savedLanguage;
    }

    const browserLanguage = navigator.language;
    if (browserLanguage) {
      const mappedLanguage = browserLanguage.startsWith('uk')
        ? 'uk_UA'
        : browserLanguage.startsWith('ru')
        ? 'ru_UA'
        : 'en_US';
      return mappedLanguage;
    }

    return 'en_US';
  };

  const initialLanguage = getInitialLanguage();
  if (initialLanguage !== 'en_US') {
    updateMomentLocale(initialLanguage);
  }

  let currentLanguage = initialLanguage;

  const handleLanguageChange = () => {
    const state = store.getState();

    let newLanguage = null;

    if (state.locale?.languages?.length > 0) {
      const activeLanguageObj = state.locale.languages.find((lang) => lang.active);
      newLanguage = activeLanguageObj?.code;
    }

    if (newLanguage && newLanguage !== currentLanguage) {
      currentLanguage = newLanguage;
      updateMomentLocale(newLanguage);
      localStorage.setItem('activeLanguage', newLanguage);
    }
  };

  store.subscribe(handleLanguageChange);

  setTimeout(() => {
    handleLanguageChange();
  }, 1000);

  window.addEventListener('languageChanged', (event) => {
    if (event.detail?.language) {
      updateMomentLocale(event.detail.language);
      localStorage.setItem('activeLanguage', event.detail.language);
    }
  });
};
